module.exports = __webpack_public_path__ + "media/images/flags/DJ-f9d5a64d9e42b89f2f5fbb9ff16aff06.svg";